import React from 'react';
import PropTypes from 'prop-types';
import { ModalFooter, Button } from 'reactstrap';
import { useCancelModalContext } from '../../../context';
import { CANCEL_MODAL_STEPS } from '../../../constants';

/**
 * Reusable modal footer component for the cancellation flow
 * Handles navigation buttons and their states
 * Now uses context to access state and actions
 */
const CancelModalFooter = ({ onKeepMembership }) => {
  // Get needed state and actions from context
  const { currentStep, isFirstStep, isLastStep, formState, actions, stepManager } = useCancelModalContext();
  // Hide footer on pause offer, downgrade offer, confirmation steps, and final steps as they have their own buttons
  if (currentStep !== CANCEL_MODAL_STEPS.REASON_SELECTION) {
    return null;
  }

  return (
    <ModalFooter>
      <div className="w-100 d-flex justify-content-between">
        <div>
          {!isFirstStep && (
            <Button color="secondary" onClick={stepManager.goBack}>
              Back
            </Button>
          )}
        </div>
        <div>
          <Button color="primary" onClick={onKeepMembership} className="mr-3">
            Keep My Membership
          </Button>
          {!isLastStep && (
            <Button
              color="secondary"
              onClick={actions.flow.proceedToCancel}
              disabled={!formState.isValid}
              className="me-3"
            >
              Proceed to cancel
            </Button>
          )}
        </div>
      </div>
    </ModalFooter>
  );
};

CancelModalFooter.propTypes = {
  onKeepMembership: PropTypes.func.isRequired
};

export default CancelModalFooter;
